import styled from 'styled-components';
import { colors, spacing, themes } from '@chegg-ui/theme';
export var LoginView = styled.div.withConfig({
  componentId: "sc-1kvnzyx-0"
})(["display:flex;flex-direction:column;gap:", ";button[disabled]{color:", ";background-color:", ";opacity:0.2;}"], themes.horizon.spacing.xl, colors.white, themes.horizon.colors.primary.dark);
export var CredentialsView = styled.div.withConfig({
  componentId: "sc-1kvnzyx-1"
})(["display:flex;flex-direction:column;gap:", ";"], spacing.px8);
export var Form = styled.form.withConfig({
  componentId: "sc-1kvnzyx-2"
})(["display:flex;flex-direction:column;gap:", ";"], themes.horizon.spacing.xl);